import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

/**
 * Aviso no bloqueante cuando hay datos (quizá antiguos) pero la API falla.
 */
const ApiStatusIndicator = ({ apiStatus, error, retryCount, onRetry, chainName }) => {
  // Solo mostrar si hay problemas o reintentos
  const shouldShow = error || apiStatus.status !== 'healthy' || retryCount > 0;
  if (!shouldShow) return null;

  // Con error activo, el aviso lo refleja (apiStatus puede ser un stub que siempre dice 'healthy')
  const message = error ? 'Connection issues detected' : apiStatus.message;

  return (
    <div className="card border-amber-200 bg-amber-50 px-5 py-4 flex flex-wrap items-start gap-3" role="status">
      <AlertTriangle size={20} className="text-amber-600 shrink-0 mt-0.5" aria-hidden="true" />
      <div className="flex-1 min-w-0 text-sm">
        <p className="font-medium text-amber-900">{chainName} API: {message}</p>
        {error && <p className="mt-1 text-amber-800 break-words">{error}</p>}
        <p className="mt-1 text-amber-800">
          Showing the last data we received. It will retry automatically
          {retryCount > 0 ? ` (failed attempts: ${retryCount})` : ''}.
        </p>
      </div>
      {error && retryCount > 0 && onRetry && (
        <button type="button" onClick={onRetry} className="btn-secondary inline-flex items-center gap-2 h-9 px-3 text-sm font-medium">
          <RefreshCw size={14} />
          Retry
        </button>
      )}
    </div>
  );
};

export default ApiStatusIndicator;
